module.exports = __webpack_public_path__ + "static/img/齿轮模型.1829d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/齿轮模型.jpg
// module id = u26P
// module chunks = 1